import styles from '../../assets/scss/components/campaigns/campaign-summary.module.scss'
import { FC } from 'react'
import { useI18n } from '../i18n.client'

export const CampaignSummary: FC<{ description: string; title: string; translate?: boolean }> = ({
  description,
  title,
  translate = false,
}) => {
  const [i18n] = useI18n()

  return (
    <div className={styles.campaignSummary}>
      <h1 className={styles.title} dangerouslySetInnerHTML={{ __html: translate ? i18n.translate(title) : title }} />
      <p className={styles.description}>{translate ? i18n.translate(description) : description}</p>
    </div>
  )
}
